import { set, get } from 'lodash'
import ls from 'local-storage'

export default {
  data () {
    return {
      rules: {
        'name': [
          { required: true, message: 'Tên không thể để trống', trigger: 'change' },
          { min: 5, max: 255, message: 'Tên phải chứa từ 5 đến 255 ký tự', trigger: 'change' }
        ],
        'short_name': [
          { required: true, message: 'Tên rút gọn không thể để trống', trigger: 'change' }
        ],
        'service_fee': [
          { required: true, message: 'Phí dịch vụ không thể để trống', trigger: 'change' }
        ]
      },
      logo: {},
      localCarrier: {
        // return_fee: 0,
        vat_fee: 0,
        insurrance_fee: 0,
        oil_fee: 0,
        remote_area_fee: 0,
        remote_area_unit: 0,
        logo: undefined,
        name: '',
        short_name: '',
        tracking_url: '',
        is_cash: false,
        service_fee: 0
      },
      uploadLogoUrl: process.env.API_URI + '/carriers/images',
      uploadHeader: {},
      submitting: false
    }
  },
  methods: {
    handleLogoUpload (res, file) {
      if (res.code) {
        this.logo = res.data
        this.localCarrier.logo = res.data.name
      }
    },
    beforeLogoUpload (file) {

    },
    removeZero (key) {
      if (parseInt(get(this.localCarrier, key)) === 0) {
        set(this.localCarrier, key, '')
      }
    },
    addZero (key) {
      if (get(this.localCarrier, key) === '') {
        set(this.localCarrier, key, 0)
      }
    },
    newCarrier () {
      this.localCarrier = {
        // return_fee: 0,
        vat_fee: 0,
        insurrance_fee: 0,
        oil_fee: 0,
        remote_area_fee: 0,
        remote_area_unit: 0,
        logo: undefined,
        name: '',
        short_name: '',
        tracking_url: '',
        is_cash: false,
        service_fee: 0
      }
    }
  },
  mounted () {
    this.newCarrier()
    this.uploadHeader.Authorization = `Bearer ${ls.get('authen').access_token}`
  },
  watch: {
    localCarrier: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/carrier/mixins/index.js